export enum DeviceStatusFlags {
	Ok = 0x0000,
	Offline = 0x0001,
	CoverOpen = 0x0002,
	LowPaper = 0x0004,
	OutOfPaper = 0x0008,
	NoRecoverError = 0x0010,
	RecoverError = 0x0020,
	SerialSettingsError = 0x0040,
	SendStatusQueryFailed = 0x0080,
	ReadStatusQueryFailed = 0x0100,
	PaperJam = 0x0200,
	FDeviceBusy = 0x0400,
	MonitorOutOfRange = 0x0800,
	DeviceFull = 0x1000,
}

export interface StatusDetails {
	[key: string]: string;
}

export interface RawKioDeviceStatus {
	Status: DeviceStatusFlags;
	Details: StatusDetails;
}

export interface KioDeviceStatus {
	statusBits: DeviceStatusFlags;
	details: StatusDetails;
}

export default interface MonitoredDevice {
	getStatus(): KioDeviceStatus;
}
